import { Injectable } from '@angular/core';

@Injectable()
export class EventService {

    constructor() { }

    private eventsDisplayed: boolean = false;
    public errorLogLength: number = 0;
    public enableEventDisplay(eventsDisplayed: boolean) {
        this.eventsDisplayed = eventsDisplayed;
    }

    public isEventDisplayed(): boolean {
        return this.eventsDisplayed;
    }
}